export default {
  title: "Documents",
  titleLarge: 'Documents from AO "EXPOCENTRE"',
  notification:
    "Print out the certificates in duplicate, sign and stamp.Take the signed certificates to the exhibition for exchange of closing documents",
  issuedInvoices: "Contracts and invoices",
  acts: "Acceptance certificates",
  titleStatusPay: "Payment status",
  invoiceNumber: "Invoice No.",
  invoiceLocation: {
    part1: "Invoices from authorized partners can be downloaded in the",
    part2: "My Orders."
  },
  contractNumber: "Agreement No.",
  contractNumberAndDate: "No. and date of agreement",
  numberAct: "Certificate No.",
  date: "Date",
  invoiceAmount: "Invoice amount",
  sumAct: "Certificate amount",
  sum: "Amount",
  downloadFile: "Download file",
  downloadFileShort: "Download",
  showFile: "Open",
  printFile: "Print",
  copyFile: "Copy",
  deleteFile: "Delete",
  collapse: "Collapse",
  more: "More information",
  number: "No.",
  status: "Status",
  paid: "Paid",
  contractNumberAndDateContent: "{number} of {date}",
  invoiceDateNumber: "Invoice №{number} of {date}",
  downloadForm1: "Download the sample power of attorney",
  downloadForm2: "here ",
  edoExchange: "Exchange in EDO",
  edoSettings: "EDO settings"
};
